/**
 * @generated SignedSource<<aadb7840dc99587e762cb97a0b24c901>>
 * @relayHash 3b2d08b5703a2a2f1733aeb2405146a6
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b2d08b5703a2a2f1733aeb2405146a6

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type useTreatmentQuery$variables = Record<PropertyKey, never>;
export type useTreatmentQuery$data = {
  readonly allMyTreatmentPlanTemplates: ReadonlyArray<{
    readonly countries: ReadonlyArray<Country>;
    readonly id: string;
    readonly languages: ReadonlyArray<{
      readonly language: Language;
      readonly synonym: string | null;
      readonly title: string;
    }>;
    readonly name: string;
  }>;
};
export type useTreatmentQuery = {
  response: useTreatmentQuery$data;
  variables: useTreatmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TreatmentPlanTemplate",
    "kind": "LinkedField",
    "name": "allMyTreatmentPlanTemplates",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countries",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TreatmentPlanTemplateLanguage",
        "kind": "LinkedField",
        "name": "languages",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "synonym",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTreatmentQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useTreatmentQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "3b2d08b5703a2a2f1733aeb2405146a6",
    "metadata": {},
    "name": "useTreatmentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6684a2abaa307a6962c22570b7597d89";

export default node;
